var _rect, _path, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 41,
    viewBox: "0 0 41 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40.097,
    height: 40.097,
    rx: 8.39241,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.2635 13.2021C12.8492 13.2021 14.1346 11.9166 14.1346 10.331C14.1346 8.74533 12.8492 7.4599 11.2635 7.4599C9.67788 7.4599 8.39246 8.74533 8.39246 10.331C8.39246 11.9166 9.67788 13.2021 11.2635 13.2021ZM14.1347 17.3983C14.1347 15.8127 12.8493 14.5272 11.2636 14.5272C9.67796 14.5272 8.39253 15.8127 8.39253 17.3983V25.4085C8.39253 26.9941 9.67796 28.2796 11.2636 28.2796H13.2683V29.7618C13.2683 31.3475 14.5537 32.6329 16.1394 32.6329C17.725 32.6329 19.0104 31.3475 19.0104 29.7618V25.4085C19.0104 23.8228 17.725 22.5374 16.1394 22.5374H14.1347V17.3983ZM17.0058 17.3983C17.0058 15.8127 18.2912 14.5272 19.8768 14.5272H30.3249C31.9105 14.5272 33.196 15.8127 33.196 17.3983C33.196 18.984 31.9105 20.2694 30.3249 20.2694H27.8274V29.766C27.8274 31.3517 26.542 32.6371 24.9564 32.6371C23.3707 32.6371 22.0853 31.3517 22.0853 29.766V20.2694H19.8768C18.2912 20.2694 17.0058 18.984 17.0058 17.3983Z",
    fill: "url(#paint0_linear_134_173)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_134_173",
    x1: 10.5,
    y1: 9,
    x2: 32.4979,
    y2: 32.502,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9E3DFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3840FF"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/Logo.c121ad4f3af6eaab7985f5c9d45f917e.svg";
export { ForwardRef as ReactComponent };